<template>
  <div>
    <div class="d-flex schedule-btns">
      <button
        :class="{ active: view === 'list' }"
        class="schedule-btn"
        @click="view = 'list'"
      >
        List View
      </button>
      <button
        :class="{ active: view === 'calendar' }"
        class="schedule-btn"
        @click="view = 'calendar'"
      >
        Calendar View
      </button>
    </div>
    <ScheduleCalendar :profile="profile" v-if="view === 'calendar'" />
    <ListCalendar :profile="profile" v-if="view === 'list'" />
  </div>
</template>

<script>
import ScheduleCalendar from "../scheduleCalendar/index.vue";
import ListCalendar from "../listCalendar/index.vue";
export default {
  name: "Schedule",
  data() {
    return {
      view: "list" // list | calendar
    };
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ScheduleCalendar,
    ListCalendar
  }
};
</script>

<style lang="scss" scoped>
.schedule-btns {
  column-gap: 12px;
  margin-bottom: 24px;
  .schedule-btn {
    height: 35px;
    border: 1px solid #f3f6f9;
    background: #f3f6f9;
    border-radius: 8px;
    padding: 0px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #474d52;
    transition: all 0.2s ease-in-out;

    &:hover,
    &.active {
      border: 1px solid #557efb;
      background: #557efb;
      color: #ffffff;
    }
  }
}
</style>
